import { ReactComponent as Edit } from "../../../../assets/images/icon/edit.svg";
import { ReactComponent as Trash } from "../../../../assets/images/icon/trash.svg";
import { ReactComponent as Eye } from "../../../../assets/images/icon/eye.svg";
import { ReactComponent as Check } from "../../../../assets/images/icon/check.svg";
import { ReactComponent as EyeDisable } from "../../../../assets/images/icon/eye-disable.svg";
import {
  myFeedBottomSheetDataList,
  useUpdateFeedWeb,
} from "../myFeedBottomSheet/model";
import { BottomSheet, CustomToast } from "../../../../shared";
import { useLocation, useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import LoadingBig from "../../../../assets/images/lottie/loading_big.json";
import Lottie from "lottie-react";
import { useState } from "react";
import ConfirmModal from "../../../../shared/modal/confirmModal";

interface IProps {
  selectedFeed?: IGetMyFeedWebResponse;
  isShowBottomSheet: boolean;
  setIsShowBottomSheet: React.Dispatch<React.SetStateAction<boolean>>;
  onToastChange?: Function
  styles?: { toast?: React.CSSProperties }
}

const MyFeedBottomSheet = ({
  selectedFeed,
  isShowBottomSheet,
  setIsShowBottomSheet,
  onToastChange,
  styles
}: IProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const updateFeedWeb = useUpdateFeedWeb();
  const queryClient = useQueryClient();
  const [deleteOpen, setDeleteOpen] = useState<boolean>(false);
  const [toastOpen, setToastOpen] = useState<boolean>(false);
  const [toastText, setToastText] = useState<React.ReactNode | string>("");

  const handleToast = (value: boolean) => {
    setToastOpen(value);
    onToastChange?.(value);
  }
  const handleSetValue = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    data: IBottomSheet
  ) => {
    if (!selectedFeed) return;
    if (updateFeedWeb.isPending) return;

    switch (data.value) {
      case "isShow":
        const isShowRequest = {
          id: selectedFeed.id,
          isShow: !selectedFeed.isShow,
        };

        updateFeedWeb.mutate(isShowRequest, {
          onSuccess: (res) => {
            if (res.data) {
              setToastText(<div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                }}
              >
                {isShowRequest.isShow ? (
                  <>
                    <Eye width={16} height={16} fill={"var(--secondarys100)"} />
                    <div>게시글이 공개되었습니다.</div>
                  </>
                ) : (
                  <>
                    <EyeDisable
                      width={16}
                      height={16}
                      stroke={"var(--secondarys100)"}
                      fill={"var(--secondarys100)"}
                    />
                    <div>게시글을 나만 보기로 설정했습니다.</div>
                  </>
                )}
              </div>

              );
              handleToast(true)
              setIsShowBottomSheet(false);
              queryClient.invalidateQueries({
                predicate: (query) => {
                  return Array.isArray(query.queryKey) && query.queryKey[0] === 'feedList';
                }
              });
              queryClient.invalidateQueries({
                queryKey: ["feedWebByFeedId", selectedFeed.id],
              });
            }
          },
        });
        break;
      case "edit":
        navigate(`/update/feed/${selectedFeed.id}`);
        break;
      case "delete":
        setDeleteOpen(true);
        setIsShowBottomSheet(false);
        break;
    }
  };

  const onDeleteOkOnClick = () => {
    if (!selectedFeed) return;

    const isDeleteRequest = { id: selectedFeed.id, isDelete: true };

    updateFeedWeb.mutate(isDeleteRequest, {
      onSuccess: (res) => {
        if (res.data) {
          queryClient.invalidateQueries({
            predicate: (query) => {
              return Array.isArray(query.queryKey) && query.queryKey[0] === 'feedList';
            }
          })
            .then(() => {
              setDeleteOpen(false);
              if (location.pathname !== "/community") {
                navigate("/community?isToast=isDeleteToast")
              } else {
                setToastText(<div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                  }}
                >
                  <Check width={16} height={16} stroke={"var(--secondarys100)"} />
                  <div className="body/b2 base/white">삭제했습니다</div>
                </div>)
                handleToast(true);
              }
            });
        }
      },
    });
  };

  return (
    <>
      <BottomSheet
        onCustomContentNode={(data) => (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "var(--space12)",
              width: "100%",
            }}
          >
            {data.value === "edit" ? (
              <Edit width={16} height={16} fill="var(--secondarys400)" />
            ) : data.value === "delete" ? (
              <Trash width={16} height={16} stroke="var(--secondarys400)" />
            ) : data.value === "isShow" && selectedFeed?.isShow ? (
              <EyeDisable
                width={16}
                height={16}
                stroke={
                  updateFeedWeb.isPending
                    ? "var(--secondarys300)"
                    : "var(--secondarys400)"
                }
                fill={
                  updateFeedWeb.isPending
                    ? "var(--secondarys300)"
                    : "var(--secondarys400)"
                }
              />
            ) : (
              <Eye
                width={16}
                height={16}
                fill={
                  updateFeedWeb.isPending
                    ? "var(--secondarys300)"
                    : "var(--secondarys400)"
                }
              />
            )}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                color: "red",
              }}
            >
              <div
                className={
                  "body/b3 " +
                  (data.value === "isShow" && updateFeedWeb.isPending
                    ? "secondary/s400"
                    : "secondary/s800")
                }
              >
                {data.value === "isShow" && !selectedFeed?.isShow
                  ? "공개"
                  : data.label}
              </div>
              {data.value === "isShow" && updateFeedWeb.isPending && (
                <Lottie
                  style={{ width: 16, height: 16, padding: "8px" }}
                  animationData={LoadingBig}
                  autoplay={true}
                />
              )}
            </div>
          </div>
        )}
        customContentHeight={48}
        isOpen={isShowBottomSheet}
        setIsOpen={setIsShowBottomSheet}
        dataList={myFeedBottomSheetDataList.filter((q) =>
          selectedFeed?.isHiddenByClaim ? q.id === 2 : true
        )}
        isShowLabel={false}
        styles={{
          modalContent: {
            borderRadius: "16px 16px 0 0",
          },
          data: { padding: "8px 0" },
        }}
        onClick={handleSetValue}
      />
      <ConfirmModal
        open={deleteOpen}
        setOpen={setDeleteOpen}
        modalStyles={{ body: { padding: "20px 16px" } }}
        classNames={{ okBtn: 'sub-title/st3', cancelBtn: 'sub-title/st3' }}
        title="게시글 삭제"
        content="작성한 게시글을 삭제하시겠습니까?"
        cancelBtn="돌아가기"
        okBtn="게시글 삭제"
        onCancelClick={() => {
          setDeleteOpen(false);
        }}
        onOkClick={onDeleteOkOnClick}
        okLoading={
          updateFeedWeb.isPending ||
          queryClient.isFetching({ queryKey: ["feedList"] }) === 1
        }
      />
      {toastOpen && selectedFeed && (
        <CustomToast
          duration={3000}
          text={toastText}
          setToast={handleToast}
          style={{
            backgroundColor: "var(--dimd300)",
            ...styles?.toast
          }}
        />
      )}
    </>
  );
};

export default MyFeedBottomSheet;
